module.exports = __webpack_public_path__ + "static/media/22ESCWA6.1762fb87.jpg";